export default "__VITE_ASSET__LM77o_I5__"